import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
const notFoundPath = '/not-found';

export default function NotFound() {
  const location = useLocation();
  const history = useHistory();
  if (location.pathname !== notFoundPath) {
    history.push(notFoundPath);
  }

  return (
    <div className="padding-default container">
      <h1 className="display-4">Page Not Found</h1>
      <p>Sorry, this page does not exist</p>
    </div>
  );
}
